import Vue from 'vue'

import InputDateRange from '../components/MasterDataLandingpage/input-date-range.vue'
import MasterDataInputList from '../components/MasterDataLandingpage/master-data-input-list.vue'

const mixin = {
  components: {
    InputDateRange,
    MasterDataInputList,
  },
}

Vue.mixin(mixin)

export { mixin }
